export const useSuperSeoMeta = (data, config) => {
	const seoMeta = { ...config.public.seoMeta }

	// robots (default elsewhere is "index, follow") this only overwrites that if one of the values are present in data.seo
	if (data.seo && ('no_index' in data.seo || 'no_follow' in data.seo)) {
		seoMeta['robots'] = `${data.seo.no_index ? 'noindex' : 'index'}, ${data.seo.no_follow ? 'nofollow' : 'follow'}`
	}

	// title
	if (data.seo?.title) seoMeta['title'] = `${config.public.clientName} — ${data.seo.title}`
	else if (data?.display_title && data?.display_title) seoMeta['title'] = `${config.public.clientName} — ${stripHtml(data.display_title)}`
	else if (data?.title && data?.title !== 'Home') seoMeta['title'] = `${config.public.clientName} — ${data.title}`

	// ogTitle
	if (data.seo?.title) seoMeta['ogTitle'] = `${config.public.clientName} — ${data.seo.title}`
	else if (data?.display_title) seoMeta['ogTitle'] = `${config.public.clientName} — ${stripHtml(data.display_title)}`
	else if (data?.title && data?.title !== 'Home') seoMeta['ogTitle'] = `${config.public.clientName} — ${data.title}`

	// description
	if (data.seo?.meta_description) seoMeta['description'] = `${data.seo.meta_description}`
	else if (data.intro) seoMeta['description'] = `${stripHtml(data.intro)}`

	// ogDescription
	if (data.seo?.meta_description) seoMeta['ogDescription'] = `${data.seo.meta_description}`
	else if (data.intro) seoMeta['ogDescription'] = `${stripHtml(data.intro)}`

	// keywords
	if (data.seo?.focus_keyphrase) seoMeta['keywords'] = `${data.seo.focus_keyphrase}`
	if (config.public.url) seoMeta['ogUrl'] = `${config.public.frontBase}${config.public.url}`

	// // ogImage
	if (data.seo?.og_image) seoMeta['ogImage'] = `${config.public.mediaBase}${data.seo.og_image}?width=1200&height=630&fit=cover`
	// if (data.seo?.og_image) seoMeta['ogImage'] = `${config.public.mediaBase}${data.seo.og_image}`
	if (data.seo?.og_image) seoMeta['ogImageHeight'] = `630`
	if (data.seo?.og_image) seoMeta['ogImageWidth'] = `1200`


	useSeoMeta(seoMeta)
}

